import { call, cancel, delay, fork, put, select, take } from 'typed-redux-saga'
import { chatSocketSelector, chatSocketSlice } from 'Pages/chat'
import { createChatWsConnection } from './createChatWsConnection'

function* reconnectTask() {
	while (true) {
		yield* delay(20000)

		const prevPing = yield* select(chatSocketSelector.selectPrevPing)
		const currentPing = yield* select(chatSocketSelector.selectCurrentPing)

		if (prevPing === currentPing) {
			yield* call(createChatWsConnection)
		} else {
			yield* put(chatSocketSlice.actions.setPrevPing(currentPing))
		}
	}
}

export function* reconnectChatPingWatcher() {
	const task = yield* fork(reconnectTask)
	yield* take(chatSocketSlice.actions.closeConnection)
	yield* cancel(task)
}
